export default __webpack_public_path__ + "static/media/pomerania-employers-banner-mobile.f297d916.jpg";